import { motion } from 'framer-motion'
import { BoatIndicator } from '../ui/BoatIndicator'
import type { RaceParticipant } from '../../types'

interface MiniMapProps {
  participants: RaceParticipant[]
  currentParticipantId: string
  className?: string
}

export function MiniMap({
  participants,
  currentParticipantId,
  className = '',
}: MiniMapProps) {
  const sortedParticipants = [...participants]
    .sort((a, b) => a.current_position - b.current_position)
    .slice(0, 5) // Show top 5

  return (
    <div className={`space-y-2 ${className}`}>
      <div className="text-sm uppercase text-gray-400 font-quicksand mb-3">
        Top 5 Standings
      </div>

      <div className="space-y-2">
        {sortedParticipants.map((participant, index) => {
          const isCurrent = participant.id === currentParticipantId
          const gap = index > 0 ? participants[index].total_laps - participants[0].total_laps : 0

          return (
            <motion.div
              key={participant.id}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1 }}
              className={`
                flex items-center gap-3 p-2 rounded-lg
                ${
                  isCurrent
                    ? 'bg-tropical-green bg-opacity-20 border border-tropical-green'
                    : 'bg-palm-dark bg-opacity-40'
                }
                transition-all duration-300
              `}
            >
              {/* Position Badge */}
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-paradise-blue text-palm-dark font-fredoka font-700 text-sm">
                {participant.current_position}
              </div>

              {/* Boat Indicator */}
              <BoatIndicator
                boatNumber={participant.boat_number}
                color={participant.boat_color}
                size="sm"
              />

              {/* Pilot Name */}
              <div className="flex-1 min-w-0">
                <div
                  className={`font-fredoka font-600 truncate ${
                    isCurrent ? 'text-tropical-green' : 'text-sand-light'
                  }`}
                >
                  {participant.pilot_name}
                </div>
              </div>

              {/* Gap */}
              {gap !== 0 && (
                <div className="text-xs text-coral-orange font-fredoka">
                  {gap > 0 ? `+${gap}` : `${gap}`}
                </div>
              )}
            </motion.div>
          )
        })}
      </div>
    </div>
  )
}
